export default "__VITE_ASSET__DO6WMrQE__ 1000w";